export default "__VITE_ASSET__2f5a61c5__"